<template>
  <div
    class="
      max-w-5xl
      p-6
      mx-auto
      static
      top-0
      left-72
      right-0
      z-50
      mt-20
      rounded-md
      shadow-md
      modal-box
      mb-20
      border-2 border-blue-500
    "
  >
    <div
      class="cursor-pointer absolute right-5 top-2"
      @click="rquirementModalclose"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 cursor-pointer"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <div class="overflow-y-auto relative">
      <h1 class="text-2xl font-bold text-theme-black capitalize">
        <span>Post Requirement</span>
      </h1>

      <form class="p-2 grid grid-cols-3 gap-5 w-full">
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Job Title</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 text-theme-black"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </div>

            <select
              v-model="jobid"
              @change="getPrice"
              class="select select-bordered w-full pl-12 focusring select-sm"
            >
              <option v-for="job in jobtitles" :key="job.id" :value="job.id">
                {{ job.title }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">No.Of.Posts</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>

            <input
              v-model="noOfPosts"
              type="number"
              placeholder="Number of requirement for job"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>

        <div class="form-control">
          <label class="label mb-2">
            <span class="label-text font-bold tracking-wide"
              >Qualifications</span
            >
            <span class="text-xs text-blue-500">
              <strong class="text-red-500">*</strong> Select Maximum 3
              Qualification</span
            >
          </label>

          <selectic
            class="w-full selective"
            :options="options"
            v-model="qualification"
            multiple
            @input="onChange"
          />
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide"
              >Approximate Salary</span
            >
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>

            <input
              v-model="approxSalary"
              type="number"
              placeholder="Approximate Salary"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide"
              >Experience Preferred</span
            >
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <input
              v-model="experience"
              type="text"
              placeholder="Job Experience"
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Package</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                />
              </svg>
            </div>

            <select
              :disabled="dataThere"
              v-model="millpackage"
              @change="findPrice"
              class="select select-bordered w-full pl-12 focusring select-sm"
            >
              <option value="1">Only Application</option>
              <option value="2">Application and Scrutinising</option>
              <option value="3">Level 2 and Interview</option>
              <option value="4">Level 2 and Interview with experts</option>
            </select>
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Package Fee</span>
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <input
              v-model="packageFee"
              type="text"
              placeholder="Package Fee"
              disabled
              class="input input-bordered w-full pl-12 focusring input-sm"
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span class="label-text font-bold tracking-wide">Remarks </span>
          </label>
          <div class="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 absolute top-3 ml-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
            <textarea
              v-model="remarks"
              class="
                textarea
                h-32
                textarea-bordered
                w-full
                pl-11
                pr-5
                focusring
              "
              placeholder="remarks"
            ></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="flex justify-center mt-10">
      <button
        :disabled="clicked"
        @click="reqSubmit"
        class="
          px-6
          py-2
          font-bold
          tracking-wide
          transition-colors
          duration-200
          transform
          bg-blue-500
          text-blue-100
          rounded-xl
          hover:bg-blue-600 hover:text-blue-300
          focus:outline-none focus:bg-blue-600
        "
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import Selectic from "selectic";
import axios from "axios";
export default {
  name: "Requirement",
  props: ["rquirementModalclose"],
  components: { Selectic },
  data() {
    return {
      dataThere: true,
      clicked: false,
      jobid: "",
      noOfPosts: Number(""),
      qualification: [],
      approxSalary: Number(""),
      experience: "",
      millpackage: Number(""),
      packageFee: "",
      priceData: [],
      jobTitle: "",
      remarks: "",
      jobtitles: [
        {
          id: 1,
          title: "Shift supervisor",
        },
        {
          id: 2,
          title: "Assistant spinning master",
        },
        {
          id: 3,
          title: "Spinning master",
        },
        {
          id: 4,
          title: "Factory manager",
        },
        {
          id: 5,
          title: "General manager",
        },
        {
          id: 6,
          title: "Vice president",
        },
      ],
      options: [
        { id: 1, text: "10th" },
        { id: 2, text: "12th" },
        { id: 3, text: "Diploma" },
        { id: 4, text: "B.Tech.Textiles" },
        { id: 5, text: "M.Tech.Textiles" },
        { id: 6, text: "Phd" },
      ],
    };
  },
  methods: {
    onChange(e) {
      this.qualification.push({ data: e });
    },
    clearData() {
      (this.jobTitle = ""),
        (this.noOfPosts = Number("")),
        (this.qualification = []),
        (this.approxSalary = Number("")),
        (this.experience = ""),
        (this.millpackage = ""),
        (this.packageFee = Number(""));
      this.rquirementModalclose();
    },
    reqSubmit() {
      this.clicked = true;
      let data = JSON.stringify({
        regId: sessionStorage.getItem("millId"),
        jobTitle: this.jobTitle,
        noOfPosts: this.noOfPosts,
        qualification: this.qualification[0].data[0],
        qualification1: this.qualification[0].data[1],
        qualification2: this.qualification[0].data[2],
        aproxSalary: this.approxSalary,
        appExp: this.experience,
        packageType: this.millpackage,
        fees: this.packageFee,
        remarks: this.remarks,
      });
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/MillRequirement`,
          data
        )
        .then((res) => {
          if (res.data.data) {
            this.clearData();
            this.clicked = false;
          } else {
            alert("Error Saving Data");
            this.clicked = false;
          }
        })
        .catch((err) => {
          if (err) {
            alert("Error Sending Data");
            this.clicked = false;
          }
        });
    },
    getPrice() {
      this.jobtitles.forEach((e) => {
        if (e.id === this.jobid) {
          this.jobTitle = e.title;
        }
      });

      let jdata = JSON.stringify({
        jobId: this.jobid,
      });
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/MillPackageFee`,
          jdata
        )
        .then((res) => {
          if (res.data.data.length == 1) {
            this.dataThere = false;
            this.priceData.push(...res.data.data);
          } else {
            this.dataThere = true;
            alert("Try again later");
          }
        })
        .catch((err) => console.log(err));
    },
    findPrice() {
      if (this.millpackage === "1") {
        this.packageFee = this.priceData[0].opt1;
      } else if (this.millpackage === "2") {
        this.packageFee = this.priceData[0].opt2;
      } else if (this.millpackage === "3") {
        this.packageFee = this.priceData[0].opt3;
      } else if (this.millpackage === "4") {
        this.packageFee = this.priceData[0].opt4;
      }
    },
  },
};
</script>

<style>
.selectic__input-value {
  position: relative;
  width: 100%;
  margin-bottom: 0px;
  top: 0px;
}

.filter-input {
  margin-top: 50px;
  padding: 5px;
}
.has-feedback {
  position: absolute;
  top: -30px;
  border: 2px;
  border-radius: 5px;
}
.selectic .form-control-feedback.fa,
.selectic .form-control-feedback {
  top: -2px;
}

.selectic-input.form-control {
  display: block;
}
</style>